import React from "react";
import { Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  return (
    <>
    <Helmet>
        <title>Contact WheatBakes – Healthy Bakery Chennai</title>
        <meta
          name="description"
          content="Reach us for healthy whole wheat cakes, eggless treats, bulk orders & natural bakery products delivered across Chennai."
        />
        <link rel="canonical" href="https://wheatbakes.com/contact" />

      </Helmet>
    
    <div>
     
      <div className="py-5">
      <div data-aos="fade-up">
              <p className="text-align-center brown-text-color text-bold-600">
                CONTACT
              </p>
              <h1 className="text-align-center text-bold-600">
                From Oven To Inbox – Connect With Us For All Things Fresh & Natural.
              </h1>
            </div>
      </div>
      <Container>
      <h2 className="text-bold-600 text-align-center">Our Stores</h2>
      <div class="row mb-4">
        <div class="col-lg-6 col-xl-6 col-sm-12 my-2" data-aos="fade-right">
          <h4>C.P.Ramasamy Road</h4>
          <img className="img-fluid" src="images/gallery/alwarpet-store.jpeg" alt="alwarpet-store" />
        </div>
        <div class="col-lg-6 col-xl-6 col-sm-12 my-2" data-aos="fade-left">
          <h4>Pondy Bazaar</h4>
          <img className="img-fluid" src="images/gallery/pondy-bazaar.jpg" alt="pondy bazaar" />
        </div>        
      </div>
      </Container>
      <div className="bg-text-image-card">
        <div className="container">
          <div className="py-5">            
            <div className="row">
              <div class="col-xl-6 col-lg-6 col-md-6 mt-4">
                <div class="info-box text-center" data-aos="fade-up">
                  <span>
                    <img
                      className="mb-4"
                      src="images/phone.png"
                      alt="Phone Icon"
                    />
                  </span>
                  <label className="mb-3">Phone</label>
                  <ul class="contact-listing">
                    <li>
                      <a href="tel:+917904309386">+91 79043 09386</a>
                    </li>
                    <li>
                      <a href="tel:+918220198138">+91 82201 98138 </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 mt-4">
                <div class="info-box text-center" data-aos="fade-up">
                  <span>
                    <img
                      className="mb-4"
                      src="images/mail.png"
                      alt="Mail Icon"
                    />
                  </span>
                  <label className="mb-3">Email</label>
                  <ul class="contact-listing">
                    <li>
                      <a href="mailto:contact@wheatbakes.com">
                        contact@wheatbakes.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 mt-4">
                <div class="info-box text-center" data-aos="fade-up">
                  <span>
                    <img
                      className="mb-4"
                      src="images/location.png"
                      alt="Location Icon"
                    />
                  </span>
                  <label className="mb-3">Pondy Bazaar</label>
                  <ul class="contact-listing">
                    <li>13/6, Thanikachalam Rd, T. Nagar, Chennai – 600017</li>
                  </ul>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 mt-4">
                <div class="info-box text-center" data-aos="fade-up">
                  <span>
                    <img
                      className="mb-4"
                      src="images/location.png"
                      alt="Location Icon"
                    />
                  </span>
                  <label className="mb-3">C.P.Ramasamy Road</label>
                  <ul class="contact-listing">
                    <li>
                    77/17, C.P.Ramasamy Road, Alwarpet, Chennai - 600018
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 mt-4">
                <div class="info-box text-center" data-aos="fade-up">
                  <span>
                    <img
                      className="mb-4"
                      src="images/approved.png"
                      alt="Approved Icon"
                    />
                  </span>
                  <label className="mb-3">FSSAI LICENSE</label>
                  <p class="contact-listing">
                    12425002002244
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="py-5">
        <div className="container">
          <Row>
            <h2 className="text-bold-600 text-align-center">Our Locations</h2>
          </Row>
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12">
              <iframe title="Pondy Bazaar" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15547.775494188945!2d80.2399083!3d13.0392446!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52671b3ae85c25%3A0x85fbd942f937a723!2sWheat%20Bakes!5e0!3m2!1sen!2sin!4v1727957200724!5m2!1sen!2sin" width="100%" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>

            <div className="col-xl-6 col-lg-6 col-md-12">
              <iframe title="Alwarpet" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15547.043660938509!2d80.2318635!3d13.0508847!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267f7a6b4160b%3A0x54801ec4acbe1207!2sWheat%20Bakes!5e0!3m2!1sen!2sin!4v1727957267854!5m2!1sen!2sin" width="100%" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default Contact;
